import { useEffect } from "react";

const useSnapPixel = () => {
  useEffect(() => {
    if (window.snaptr) {
      window.snaptr("init", "099ff95b-e8bb-4c78-9679-5f1158fb0de0");
      window.snaptr("track", "PAGE_VIEW");
      return;
    }

    (function (e, t, n) {
      if (e.snaptr) return;
      var a = (e.snaptr = function () {
        a.handleRequest ? a.handleRequest.apply(a, arguments) : a.queue.push(arguments);
      });
      a.queue = [];

      var s = "script";
      var r = t.createElement(s);
      r.async = true;
      r.src = n;
      r.onload = () => {
        // инициализация после загрузки
        window.snaptr("init", "099ff95b-e8bb-4c78-9679-5f1158fb0de0");
        window.snaptr("track", "PAGE_VIEW");
      };
      var u = t.getElementsByTagName(s)[0];
      u.parentNode.insertBefore(r, u);
    })(window, document, "https://sc-static.net/scevent.min.js");
  }, []);
};

export default useSnapPixel;
